module.exports = {"title":"Raquel Vélez","talk":"undefined","path":"/speakers/raquel-velez","type":"speaker","slug":"raquel-velez","twitter":"rockbot","github":"rockbot","website":"https://rckbt.me/","companyWebsite":"https://www.npmjs.com/","company":"npm","body":"<p>Senior Software Developer at npm, Inc. She studied Mechanical Engineering at Caltech and worked as a roboticist for 8 years.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/raquel-velez.md
 ** module id = 550
 ** module chunks = 0
 **/